export const mainColors = {
  blue: "#0B406B",
  purple: "#47309C",
  skorch: "#FF8C6B",
  salmon: "#FF9F89",
  forest: "#6C7C67",
};
